const VendAccountModel = {
  edit: false,
  table: "res_partner",
  control: "meter_action",
  fields: [
    {
      name: "field",
      type: "hidden",
      value: "",
    },
    {
      name: "value",
      type: "hidden",
      value: "",
    },
    {
      name: "source",
      type: "hidden",
      value: "wallet",
    },
    {
      name: "units",
      type: "text",
      fullWidth: true,
      label: "Enter Amount",
    },
    {
      name: "action",
      type: "hidden",
      value: "vendme",
    },
  ],
  desc: "Vend Account By Wallet",
  title: "Vend Account",
};

export default VendAccountModel;

export const CashVendAccountModel = {
  edit: false,
  table: "res_partner",
  control: "meter_action",
  fields: [
    {
      name: "field",
      type: "hidden",
      value: "",
    },
    {
      name: "value",
      type: "hidden",
      value: "",
    },
    {
      name: "source",
      type: "hidden",
      value: "cash",
    },
    {
      name: "units",
      type: "text",
      fullWidth: true,
      label: "Enter Amount",
    },
    {
      name: "action",
      type: "hidden",
      value: "vendme",
    },
  ],
  desc: "Vend Account By Cash",
  title: "Vend Account",
};
